<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: { type: String, required: true },
  value: { type: Number, default: 0 },
});

const normalizedValue = computed(() =>
  Math.min(100, Math.max(0, Number(props.value) || 0))
);
const colorClass = computed(() => {
  if (normalizedValue.value >= 100) return 'accent-lais-primary';
  if (normalizedValue.value > 0) return 'accent-amber-500';
  return 'accent-lais-text-muted';
});
</script>

<template>
  <progress
    class="h-1.5 w-full rounded-full"
    :class="colorClass"
    :value="normalizedValue"
    max="100"
    :aria-label="label"
    data-test="sales-party-progress"
  />
</template>
